import { useQuery } from '@apollo/client'

import { gql } from '@web/gql'
import { User_ProfileFragment } from '@web/gql/graphql'
import { federationApolloClient } from '@web/libs/apollo/federationClient'
import { isTypename } from '@web/libs/apollo/typeGuard'

export type Me = User_ProfileFragment

interface UseMeLoadingOutput {
  loading: true
  me: null
  login: false
}

interface UseMeSuccessOutput {
  loading: false
  me: Me
  login: true
}

interface UseMeFailedOutput {
  loading: false
  me: null
  login: false
}

type UseMeOutput = UseMeLoadingOutput | UseMeSuccessOutput | UseMeFailedOutput

const fragment = gql(`
  fragment UseMe_Query on Query {
    me {
      ... on BaseError {
        message
      }
      ... on MeSucceed {
        user {
          ...User_Profile
        }
      }
    }
  }
  fragment User_Profile on User {
    id
    idno
    currentGrade
    profile {
      nickname
      imageUrl
      originImageUrl
      border {
        name
        imageUrl
      }
      introduction
      updated
      shouldNoticeReset
    }
    stat {
      followerCount
      followingCount
      followRequestCount
      followRequesterCount
      reviewCount
      imageReviewCount
      imageCount
      blockCount
    }
    isBlocked
    didIRequestFollow
    isFollowRequester
    isFriend
    isAutoAcceptingFollow
    isThemeContentProvider
  }
`)

export const meQuery = gql(`
  query Me {
    ...UseMe_Query
  }
`)

const useMe = (): UseMeOutput => {
  const { data, loading } = useQuery(meQuery, { client: federationApolloClient })

  if (loading) return { loading, me: null, login: false }

  if (data && isTypename(data.me, 'MeSucceed')) {
    const me = data.me.user

    return {
      me,
      loading: false,
      login: true,
    }
  }

  return {
    me: null,
    loading: false,
    login: false,
  }
}

export default useMe
